module.exports = __webpack_public_path__ + "static/media/signal.d929ea75.svg";